var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgColorIcoUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.06643 7.98856C11.5311 9.166 12.8554 11.0466 13 13.7225C12.7607 13.7225 12.5479 13.7225 12.3346 13.7225C12.1261 13.7225 11.9177 13.7225 11.6924 13.7225C11.6367 12.0869 10.9772 10.7458 9.62845 9.74821C8.66143 9.03361 7.55364 8.70576 6.33973 8.73912C3.66556 8.81209 1.36118 10.8725 1.30379 13.708C0.88309 13.708 0.462391 13.708 0 13.708C0.138609 11.0466 1.46785 9.16183 3.94548 7.98543C2.6666 7.07172 1.96002 5.86874 1.96543 4.33008C1.96976 3.13908 2.42836 2.10862 3.30712 1.26945C5.089 -0.431823 7.93157 -0.415666 9.70425 1.2731C11.5446 3.02546 11.6004 6.30344 9.06643 7.98856ZM6.50433 7.48036C8.29542 7.47984 9.73349 6.0986 9.7389 4.37439C9.74431 2.64392 8.29921 1.24548 6.50487 1.24443C4.70891 1.24287 3.25785 2.63715 3.25677 4.36396C3.25569 6.09234 4.70296 7.48088 6.50433 7.48036Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 6.5,
    y1: 0,
    x2: 6.5,
    y2: 13.7225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62CEA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D8CBB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorIcoUser);
export default __webpack_public_path__ + "static/media/color-ico-user.194369a3a45061462d6d8c85918d45d8.svg";
export { ForwardRef as ReactComponent };